/**
 * Created by RanAn on 2021/05/01.
 */
/* jshint esversion: 8 */
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
import ECharts from 'vue-echarts';
import * as echarts from 'echarts/core';
import wordCloud from 'echarts-wordcloud';
import App from './App.vue';
import router from './router';
import VueResource from 'vue-resource';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/timeline';
import 'echarts/lib/component/title';
import IncludeComps from './include';
import '../stylesheets/style.css';
import VueChatScroll from 'vue-chat-scroll';
import ElementLocale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import api from "@/api";
import SIP from './utils/phone/phone'
import store from './store';
// import { VueSvgIcon } from '@yzfe/vue-svgicon';
// import '@yzfe/svgicon/lib/svgicon.css';
// SVGロード機能を追加
import { loadSvg } from './icons';
import IconSvg from './components/icon-svg';
// FontAwesomeアイコンを追加（phoneコンポーネントで使用）
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.use(IncludeComps);
Vue.use(VueChatScroll);
Vue.prototype.$SIP = SIP

var _ = require("lodash");
const messages = {
  'ja': require('../static/lang/japanese.json'),
};
const i18n = new VueI18n({
  locale: 'ja',
  messages,
  silentTranslationWarn: true
});
// ==========================================
// 修正日時: 2026-01-26
// 修正内容: i18nインスタンスをグローバルにエクスポート
//           - phone.jsからVueI18nにアクセスできるようにする
//           - 言語ロジックをVueI18nに統一
// ==========================================
window.__VUE_I18N__ = i18n;
ElementLocale.i18n((key, value) => i18n.t(key, value));
// Configure ECharts global font to inherit from body
const FONT_FAMILY = "'Avenir', Helvetica, Arial, sans-serif";

// Set global textStyle for all ECharts instances
echarts.registerTheme('app_theme', {
  textStyle: {
    fontFamily: FONT_FAMILY
  }
});

// Provide default options for vue-echarts
ECharts.props.initOptions = {
  default: () => ({
    renderer: 'canvas'
  })
};

// Override the default option to include global textStyle
const originalComponent = ECharts.extends || ECharts;
Vue.component('echarts', {
  extends: originalComponent,
  props: {
    ...originalComponent.props,
    theme: {
      type: [String, Object],
      default: 'app_theme'
    } 
  },
});

Vue.component('wordCloud', wordCloud);
Vue.component('icon', IconSvg)
// icon-svgコンポーネントも登録（phoneコンポーネントで使用）
// Vue.component('icon-svg', IconSvg);
// FontAwesomeアイコンを追加
library.add(fab, fas, far);
Vue.component('font-awesome-icon', FontAwesomeIcon);
// SVGファイルをロード
loadSvg();
// utilsを追加
import utils from './utils/utils';
Vue.prototype.$utils = utils;
Vue.prototype.$bus = new Vue();

// router.push('/');

new Vue({
  el: '#app',
  router,
  store,
  data: {
    headerColor: '#00B2F2',
    fontColor: '#fff',
    htmlConst: {},
    barWidth: 5,
    showSidebar: false,
    editMode: false,
    showHistorySetting: false,
    popUpDisplay: false,
    presenceTableData: [],
    chatRealTimeTableData: [],
    chatDailyTableData: [],
    telRealTimeTableData: [],
    telDailyTableData: [],
    f2fRealTimeTableData: [],
    f2fDailyTableData: [],
    presenceNgCount: 0,
    chatNgCount: 0,
    telNgCount: 0,
    f2fNgCount: 0,
    presenceLongTimeCount: 0,
    telLongTimeCount: 0,
    personConfirmCount: 0,
    ngWordsConfig: 0,
    longTimeConfig: 0,

    usedChartList: [],
    unusedChartList: [],

    usedChartPresenceList: [],
    unusedChartPresenceList: [],

    usedChartChatList: [],
    unusedChartChatList: [],

    usedChartTelList: [],
    unusedChartTelList: [],

    usedChartF2FList: [],
    unusedChartF2FList: [],

    scrollFlg: 'true',
    barscrollFlg: 'true',
    activeName: 'presence',
    user: {},

    presenceStatusChartoption: {},
    presenceModeChartoption: {},

    chatPersonStatusOption: {},
    chatStatusChartoption: {},
    chatAnswerStatusChartoption: {},

    telStatusChartoption: {},
    releaseStatsChartoption: {},
    f2fStatusChartoption: {},

    nameless: "display",
    dailySatisfactionIndex: "",
    dailyTimeFlg: "",
    serviceUrl: '',
    redmineUrl: '',
    endDate: '',
    startDate: '',

    groupFilters: [],
    svFilters: [],
    modelFilters: [],
    statusFilters: [],

    chatRealTimeGroupFilters: [],
    chatRealTimeSvFilters: [],
    chatRealTimeStatusFilters: [],
    chatDailyGroupFilters: [],
    chatDailySvFilters: [],

    telRealTimeGroupFilters: [],
    telRealTimeSvFilters: [],
    telRealTimeStatusFilters: [],
    telDailyGroupFilters: [],
    telDailySvFilters: [],

    f2fRealTimeGroupFilters: [],
    f2fRealTimeSvFilters: [],
    f2fRealTimeStatusFilters: [],
    f2fDailyGroupFilters: [],
    f2fDailySvFilters: [],

    presenceTableHeight: 'calc(100vh - 350px)',
    chatTableHeight: '390',
    telTableHeight: '390',
    f2fTableHeight: '390',
    
    chatTable: true,
    telTable: true,
    f2fTable: true,
    isDataLoading: false,

    facetForEchart: '',
    ageForEchart: '',
    sexForEchart: '',
    allBarShowFlg: true,
    historyChatShowFlg: true,
    historyChatHeight: '100%',

    mqseqList: [],

    htmlConstRecording: {},
    categoryList: [],
    mannersList: [],
    wowList: [],
    ngWordList: [],
    contenttextList: [],
    ngArr: [],
    categoryTagArr: [],
    dialogTitle: '',
    dialogSendVal: false,

    //svDependCount
    presenceSVDependCount: 0,
    chatSVDependCount: 0,
    telSVDependCount: 0,
    f2fSVDependCount: 0,
  },

  created() {
    // api.getHtmlConst().then(
    //   (res) => {
    //     if (res && res.data && res.data.htmlConst && !res.data.error) {
    //       this.htmlConst = res.data.htmlConst;
    //     }
    //   },
    //   (err) => {
    //     console.log(err);
    //   }
    // );
  },
  // mounted() {
  //   const that = this;
  //   window.onresize = () => {
  //     return (() => {
  //       that.screenChange();
  //     })();
  //   };
  // },
  // watch: {
  //   screenWidth() {
  //     if (!this.timer) {
  //       this.timer = true;
  //       var that = this;
  //       setTimeout(function () {
  //         that.timer = false;
  //       }, 400);
  //     }
  //   }
  // },
  methods: {
    // screenChange() {
    //   var newScreenWidth;
    //   if (this.$root.usedChartNewList.length <= 2) {
    //     this.$root.barscrollFlg = 'false';
    //     newScreenWidth = document.body.clientWidth / 5 * 2;
    //     this.$root.barscreenWidth = 'width:' + newScreenWidth + "px";
    //     this.$root.barWidth = 12;
    //   } else {
    //     this.$root.barscrollFlg = 'true';
    //     newScreenWidth = document.body.clientWidth / 5 * 3;
    //     this.$root.barscreenWidth = 'width:' + newScreenWidth + "px";
    //     this.$root.barWidth = 8;
    //   }

    // },
    onClose(title) {
      var list = this.$root.usedChartList;
      for (var index in list) {
        if (list[index].name === title) {
          this.$root.unusedChartList.push(this.$root.usedChartList[index]);
          this.$root.usedChartList.splice(index, 1);

          let data = {
            user_id: this.$root.user.user_id,
            name: title,
            checkedFlg: false
          };

          api.saveUserEchartStatus(data).then(
            () => {
            },
            (err) => {
              console.log(err);
            }
          );
          break;
        }
      }

      this.$root.usedChartList = _.sortBy(
        this.$root.usedChartList,
        function (o) {
          return o.index;
        }
      );
    },
    realTimeOnClose(title) {
      if (this.$root.activeName == 'presence') {
        let list = this.$root.usedChartPresenceList;
        for (let index in list) {
          if (list[index].name === title) {
            this.$root.unusedChartPresenceList.push(this.$root.usedChartPresenceList[index]);
            this.$root.usedChartPresenceList.splice(index, 1);
          }
        }
        localStorage.setItem('usedChartPresenceList', JSON.stringify(list))
      } else if (this.$root.activeName == 'chat') {
        let list = this.$root.usedChartChatList;
        for (let index in list) {
          if (list[index].name === title) {
            this.$root.unusedChartChatList.push(this.$root.usedChartChatList[index]);
            this.$root.usedChartChatList.splice(index, 1);
          }
        }
        localStorage.setItem('usedChartChatList', JSON.stringify(list))
      } else if (this.$root.activeName == 'tel') {
        let list = this.$root.usedChartTelList;
        for (let index in list) {
          if (list[index].name === title) {
            this.$root.unusedChartTelList.push(this.$root.usedChartTelList[index]);
            this.$root.usedChartTelList.splice(index, 1);
          }
        }
        localStorage.setItem('usedChartTelList', JSON.stringify(list))
      } else if (this.$root.activeName == 'f2f') {
        let list = this.$root.usedChartF2FList;
        for (let index in list) {
          if (list[index].name === title) {
            this.$root.unusedChartF2FList.push(this.$root.usedChartF2FList[index]);
            this.$root.usedChartF2FList.splice(index, 1);
          }
        }
        localStorage.setItem('usedChartF2FList', JSON.stringify(list))
      }
      // this.screenChange();
    },
    showPopUp(displayTitle, option) {
      this.$root.popUpDisplay = true;
      this.$root.currentPopUpTitle = displayTitle;
      this.$root.currentChartData = option;
    },
  },
  render: h => h(App)
}).$mount('#app');
